<script setup>
import zhCN from 'ant-design-vue/es/locale/zh_CN'
import dayjs from 'dayjs'
import 'dayjs/locale/zh-cn'

dayjs.locale('zh-cn')
// 设置主题颜色
const data = ref({
  colorPrimary: '#52BE54',
  // borderRadius: 2,
})
const locale = zhCN
</script>

<template>
  <div>
    <a-config-provider
      :theme="{
        token: data,
        components: {
          Input: {
            borderRadius: 5,
          },
          Button: {
            borderRadius: 5,
          },
          // Popover: {
          //   borderRadius: 20,
          // },
        },
      }"
      :locale="locale"
    >
      <NuxtLayout>
        <NuxtPage />
      </NuxtLayout>
    </a-config-provider>
  </div>
</template>
